export default "__VITE_ASSET__DSwo$aTg__$_?nuxt_component=async&nuxt_component_name=SvgoLaunchpoolIcRightsText&nuxt_component_export=default__"